

import React, { useState } from "react";
import { Popover, TextField, Button, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MdAddCircleOutline, MdOutlineChangeCircle } from "react-icons/md";

const ChangeDueDateButton = ({ onSubmit }: any) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const theme = useTheme();

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSave = () => {
    if (selectedDate) {
      onSubmit(selectedDate);
    }
    handleClose();
  };

  return (
    <>
    <Button variant="contained" onClick={handleOpen} sx={{ height: '40px', borderRadius: '10px'}}>
            <MdAddCircleOutline onClick={handleOpen} style={{ width: '30px', height: '30px', color: '#FFF', fontWeight: 400 }} />
    </Button>
        
        


      
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          zIndex: theme.zIndex.modal,
        }}
      >
        <div style={{ padding: 16, display: "flex", flexDirection: "column", gap: 8 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={selectedDate}
              onChange={(newValue: any) => setSelectedDate(newValue)}
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </LocalizationProvider>
          <Button variant="contained" color="primary" onClick={handleSave}>
            <Typography color='#FFF'> Salvar </Typography>
          </Button>
        </div>
      </Popover>
    </>
  );
};

export default ChangeDueDateButton;
